function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var FixedBottomBarLayout =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FixedBottomBarLayout, _PureComponent);

  function FixedBottomBarLayout() {
    _classCallCheck(this, FixedBottomBarLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(FixedBottomBarLayout).apply(this, arguments));
  }

  _createClass(FixedBottomBarLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          barContent = _this$props.barContent,
          useFixedPositioning = _this$props.useFixedPositioning,
          isShown = _this$props.isShown;
      var className = classNames('eds-fixed-bottom-bar-layout', {
        'eds-fixed-bottom-bar-layout--absolute': !useFixedPositioning,
        'eds-fixed-bottom-bar-layout--shown': isShown
      });
      return React.createElement("div", {
        className: className,
        "data-spec": "fixed-bottom-bar-layout"
      }, React.createElement("div", {
        className: "eds-fixed-bottom-bar-layout__content"
      }, children), React.createElement("div", {
        className: "eds-fixed-bottom-bar-layout__bar"
      }, barContent));
    }
  }]);

  return FixedBottomBarLayout;
}(PureComponent);

_defineProperty(FixedBottomBarLayout, "propTypes", {
  /**
   * The main content
  */
  children: PropTypes.node.isRequired,

  /**
   * The content to include in the bottom bar
   */
  barContent: PropTypes.node,

  /**
   * Whether or not the bottom bar is positioned absolute or fixed
   * When Structure hasIndependentScrolling is true, the bottom bar needs absolute positioning.
   * For bottom bar to work without hasIndependentScrolling, it needs fixed positioning.
   */
  useFixedPositioning: PropTypes.bool,

  /**
   * Whether or not the bottom bar is shown
   */
  isShown: PropTypes.bool
});

_defineProperty(FixedBottomBarLayout, "defaultProps", {
  useFixedPositioning: false,
  isShown: false
});

export { FixedBottomBarLayout as default };